// src/pages/Checkout.jsx
import React, { useState } from "react";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import toast from "react-hot-toast";

const Checkout = () => {
  const { cart, clearCart } = useCart();
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const subtotal = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);
  const gst = subtotal * 0.18;
  const total = subtotal + gst;

  const handlePlaceOrder = async () => {
    if (!currentUser) {
      toast.error("Please login to place an order.");
      return;
    }

    setLoading(true);
    try {
      await addDoc(collection(db, "orders"), {
        userId: currentUser.uid,
        items: cart.map(({ id, name, price, quantity }) => ({
          productId: id,
          name,
          price,
          quantity,
        })),
        subtotal,
        gst,
        total,
        createdAt: serverTimestamp(),
      });

      toast.success("✅ Order placed successfully!");
      clearCart();
      navigate("/orders");
    } catch (err) {
      console.error("Order failed:", err);
      toast.error("❌ Failed to place order. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 min-h-screen bg-rose-50">
      <h1 className="text-3xl font-bold text-rose-700 mb-6">Checkout</h1>

      {cart.length === 0 ? (
        <p className="text-gray-600">Your cart is empty.</p>
      ) : (
        <div className="space-y-6 max-w-3xl mx-auto bg-white p-6 rounded-xl shadow">
          {cart.map((item) => (
            <div key={item.id} className="flex justify-between items-center">
              <div>
                <h2 className="text-lg font-semibold">{item.name}</h2>
                <p className="text-sm text-gray-600">
                  ₹{item.price} × {item.quantity}
                </p>
              </div>
              <p className="text-lg font-bold">
                ₹{(item.price * item.quantity).toFixed(2)}
              </p>
            </div>
          ))}

          <div className="border-t pt-4 text-right space-y-1 text-gray-800">
            <p>Subtotal: ₹{subtotal.toFixed(2)}</p>
            <p>GST (18%): ₹{gst.toFixed(2)}</p>
            <p className="text-xl font-bold">Total: ₹{total.toFixed(2)}</p>
          </div>

          <button
            onClick={handlePlaceOrder}
            disabled={loading}
            className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-full font-semibold w-full"
          >
            {loading ? "Placing Order..." : "Place Order"}
          </button>
        </div>
      )}
    </div>
  );
};

export default Checkout;
